module.exports = __webpack_public_path__ + "img/password-smartphone.693dcd34.svg";